import * as React from 'react';
import {
  ActionCard,
  RouteWrapper,
  Section,
  Box,
  Content,
  HeadingSection,
} from '../../components';

const Route = () => (
  <RouteWrapper
    title="Accounting"
    requireAuth
    requirePermission="MANAGE_PAYMENTS"
  >
    <HeadingSection title="Accounting" />
    <Section>
      <Content>
        <Box>
          <ActionCard
            title="Payments"
            subtitle="View all payments that have been received"
            icon="inbox"
            link="/payments"
          />
          <ActionCard
            title="Banking Exports"
            subtitle="View all end of day banking exports"
            icon="file"
            link="/payments/banking-export"
          />
          <ActionCard
            title="Accounts"
            subtitle="Manage accounts that are due"
            icon="university"
            link="/payments/pending-account"
          />
          <ActionCard
            title="Pre-Auth Bookings"
            subtitle="Resolve bookings that were paid by pre-auth"
            icon="credit-card"
            link="/payments/pre-auth"
          />
        </Box>
      </Content>
    </Section>
  </RouteWrapper>
);

export default Route;
